module.exports = __webpack_public_path__ + "img/data_analytic.e7e6fef6.svg";